import { getItem, removeItem, setItem } from './storage';

const UserCheckKey = 'lqaAcademyUserList';

function parseStoredList(rawList) {
  if (Array.isArray(rawList)) {
    return rawList;
  }

  try {
    return JSON.parse(typeof rawList === 'string' ? rawList : '[]');
  } catch (e) {
    return [];
  }
}

export function shouldShowLqaAcademyModal() {
  removeItem('lqaAcademyPopupDateStamp');
  const userData = getItem('user');
  const user = userData && userData.user;

  if (!user || !user.id) {
    return true;
  }

  const storedList = parseStoredList(getItem(UserCheckKey));
  return !storedList.includes(user.id);
}

export function addUserToSeenList() {
  const userData = getItem('user');
  const user = userData && userData.user;

  if (!user || !user.id) {
    return;
  }

  const storedList = parseStoredList(getItem(UserCheckKey));

  if (!storedList.includes(user.id)) {
    storedList.push(user.id);
    setItem(UserCheckKey, JSON.stringify(storedList));
  }
}
